var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.0007L9.16667 11.6673L12.5 8.33398",
    stroke: "#EBEBF5",
    strokeOpacity: 0.64,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79102 5.83268C4.79102 5.26119 5.26119 4.79102 5.83268 4.79102H14.166C14.4423 4.79102 14.7072 4.90076 14.9026 5.09611C15.0979 5.29146 15.2077 5.55642 15.2077 5.83268V15.2077H4.79102V5.83268ZM3.54102 15.2077H1.66602C1.32084 15.2077 1.04102 15.4875 1.04102 15.8327C1.04102 16.1779 1.32084 16.4577 1.66602 16.4577H4.16602H15.8327H18.3327C18.6779 16.4577 18.9577 16.1779 18.9577 15.8327C18.9577 15.4875 18.6779 15.2077 18.3327 15.2077H16.4577V5.83268C16.4577 5.22489 16.2162 4.642 15.7865 4.21223C15.3567 3.78246 14.7738 3.54102 14.166 3.54102H5.83268C4.57084 3.54102 3.54102 4.57084 3.54102 5.83268V15.2077Z",
    fill: "#EBEBF5",
    fillOpacity: 0.64
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVote);
export default __webpack_public_path__ + "static/media/vote.3c5f6f9d16a422615eae164c8a16c0cf.svg";
export { ForwardRef as ReactComponent };